import { Ticket } from '../../../entities/ticket';
import { getTickets } from '../../../entities/ticket/api/ticketApi';

export interface GetTicketsFilters {
  status?: string[];
  search?: string;
  site?: string;
  priority?: string;
  clientId?: string;
  limit?: number;
  offset?: number;
  updatedAfter?: string;
  orderBy?: 'created_asc' | 'created_desc' | 'updated_asc' | 'updated_desc';
}

export class GetTicketsUseCase {
  async execute(filters?: GetTicketsFilters): Promise<Ticket[]> {
    return getTickets(filters);
  }
}
